import { Tfn, Messages } from './types';
import { useTranslations, useLocale } from 'next-intl';
export { createNavigation } from 'next-intl/navigation';

export const useTranslate = useTranslations;

export { type Tfn, type Messages, useLocale };
